import React from "react";
import DashboardMenu from "../../commonComponents/DashboardMenu";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckIcon from "@mui/icons-material/Check";
import useStyles from "../DashboardAuction/dashAuction.style";
import buyerListAPI from "../../../api/adminAPI/buyerListAPI";
import { useState } from "react";
import moment from "moment";
import DashBuyerDetail from "../DashboardAuction/BidlogFirst/DashBuyerDetail";
import DashEventDetail from "../DashboardAuction/BidlogFirst/DashEventDetail";
import BuyerBidLog from "../DashboardAuction/BidlogFirst/BuyerBidLog";
import { getUserData, openAccessAccountTab } from "../../../common";
import { Navigate } from "react-router-dom";

import lodash from "lodash";
import { FaRegFileExcel } from "react-icons/fa";
import * as XLSX from "xlsx";
import buyerDeleteAPI from "../../../api/adminAPI/buyerDeleteAPI";
import buyerUpdateStatusAPI from "../../../api/adminAPI/buyerUpdateStatusAPI";
import updateBuyerAPI from "../../../api/adminAPI/updateBuyerAPI";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import accessBuyerAccountAPI from "../../../api/adminAPI/accessBuyerAccountAPI";
import LoginIcon from "@mui/icons-material/Login";

function DashBuyer() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [changeView, SetChangeView] = useState(false);
  const [buyerEventId, SetBuyerEventId] = useState("");
  const [buyerEventItemId, SetBuyerEvenItemtId] = useState("");
  const [buyerId, SetBuyerId] = useState("");
  const [selectedBuyer, setSelectedBuyer] = useState(null);

  const userData = getUserData() ?? {};

  const handleClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedBuyer(row);
    SetBuyerId(row.buyerId);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedBuyer(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const [tableBuyers, setTableBuyers] = useState([]);

  const buyerList = async () => {
    try {
      const { data } = await buyerListAPI();

      if (data) {
        let id = 1;
        const buyersData = data.map((buyer) => {
          return {
            id: id++,
            userName: `${buyer.firstName} ${buyer.lastName}`,
            firstName: buyer.firstName,
            lastName: buyer.lastName,
            email: buyer.email,
            contactNumber: buyer.contactNumber,
            alternateContactNumber: buyer.alternateContactNumber,
            buyerId: buyer.userId,
            h1RanksCount: buyer.h1RanksCount,
            h2RanksCount: buyer.h2RanksCount,
            h3RanksCount: buyer.h3RanksCount,
            totalEvents: buyer.totalEvents,
            totalBidedItems: buyer.totalBidedItems,
            totalItems: buyer.totalItems,
            allotedItems: buyer.allotedItems,
            registrationDate: buyer.createdAt,
            status: buyer.status,
          };
        });

        setTableBuyers(buyersData);
      } else throw new Error(data);
    } catch (error) {
      console.log(error);
    }
  };
  React.useEffect(() => {
    buyerList();
    return () => {
      return false;
    };
  }, []);

  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openStatusDialog, setOpenStatusDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [editForm, setEditForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    contactNumber: "",
    alternateContactNumber: "",
  });

  const handleOpenEdit = () => {
    if (!selectedBuyer) return;
    setEditForm({
      firstName: selectedBuyer.firstName || "",
      lastName: selectedBuyer.lastName || "",
      email: selectedBuyer.email || "",
      contactNumber: selectedBuyer.contactNumber || "",
      alternateContactNumber: selectedBuyer.alternateContactNumber || "",
    });
    setOpenEditDialog(true);
    setAnchorEl(null);
  };

  const handleUpdateBuyer = async () => {
    try {
      const payload = {
        firstName: editForm.firstName,
        lastName: editForm.lastName,
        email: editForm.email,
        contactNumber: editForm.contactNumber,
        alternateContactNumber: editForm.alternateContactNumber || null,
      };
      await updateBuyerAPI(payload, buyerId);
      toast("Buyer updated successfully!");
      setOpenEditDialog(false);
      await buyerList();
    } catch (error) {
      toast(error.response?.data?.error || "Failed to update buyer");
    }
  };

  const handleDeleteBuyer = async () => {
    try {
      await buyerDeleteAPI(buyerId);
      toast("Buyer deleted successfully!");
      setOpenDeleteDialog(false);
      setAnchorEl(null);
      await buyerList();
    } catch (error) {
      toast(error.response?.data?.error || "Failed to delete buyer");
    }
  };

  const handleUpdateStatus = async () => {
    try {
      const payload = {
        status: selectedBuyer?.status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
      };
      await buyerUpdateStatusAPI(payload, buyerId);
      toast("Buyer status updated successfully!");
      setOpenStatusDialog(false);
      setAnchorEl(null);
      await buyerList();
    } catch (error) {
      toast(error.response?.data?.error || "Failed to update status");
    }
  };

  const handleAccessBuyerAccount = async () => {
    if (!selectedBuyer?.buyerId) return;

    try {
      const { data } = await accessBuyerAccountAPI(selectedBuyer.buyerId);
      const opened = openAccessAccountTab({
        token: data.token,
        userData: data.user,
      });

      if (!opened) {
        return toast("Please allow popups to open the support access tab");
      }

      toast(`Support access enabled for ${selectedBuyer.userName}`);
      setAnchorEl(null);
    } catch (error) {
      toast(error.response?.data?.error || "Failed to access buyer account");
    }
  };

  const columns = [
    {
      name: "Sr. No.",
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: "User Name",
      selector: (row) => row.userName,
      sortable: true,
      width: "150px",
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      width: "300px",
    },
    {
      name: "Mobile Number",
      selector: (row) => row.contactNumber,
      sortable: true,
      width: "150px",
    },
    {
      name: "Alt. Mobile Number",
      selector: (row) => row.alternateContactNumber || "-",
      sortable: true,
      width: "180px",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      width: "130px",
    },
    {
      name: "Events",
      selector: (row) => row.totalEvents,
      sortable: true,
    },
    {
      name: "Lots",
      selector: (row) => row.totalItems,
      sortable: true,
    },
    {
      name: "Alloeted Lots",
      selector: (row) => row.allotedItems,
      sortable: true,
      width: "130px",
    },
    {
      name: "Bidded Lots",
      selector: (row) => row.totalBidedItems,
      sortable: true,
      width: "130px",
    },
    {
      name: "Lead Bid",
      selector: (row) => row.h1RanksCount,
      sortable: true,
    },
    {
      name: "L2/H2",
      selector: (row) => row.h2RanksCount,
      sortable: true,
    },
    {
      name: "Others",
      selector: (row) => row.h3RanksCount,
      sortable: true,
    },
    {
      name: "Registration Date",
      selector: (row) => moment(row.registrationDate).format("DD/MM/YYYY"),
      sortable: true,
      width: "150px",
    },
    {
      name: "Action",
      width: "150px",
      sortable: false,
      cell: (row) => (
        <div>
          <Button
            aria-describedby={id}
            variant="contained"
            onClick={(event) => handleClick(event, row)}
          >
            <MoreVertIcon />
          </Button>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
          >
            <Typography sx={{ p: 2, display: "grid" }}>
              <span
                className={classes.viewBtn}
                onClick={() => {
                  SetChangeView("DashBuyerDetail");
                  SetBuyerId(buyerId);
                  setAnchorEl(null);
                }}
              >
                <RemoveRedEyeIcon
                  style={{ color: "#2D55EB", paddingRight: "5px" }}
                />
                View
              </span>
              <span className={classes.viewBtn} onClick={handleOpenEdit}>
                <EditIcon style={{ color: "#2D55EB", paddingRight: "5px" }} />
                Edit
              </span>
              {userData.role === "ADMIN" && (
                <span
                  className={classes.viewBtn}
                  onClick={handleAccessBuyerAccount}
                >
                  <LoginIcon
                    style={{ color: "#2D55EB", paddingRight: "5px" }}
                  />
                  Access Account
                </span>
              )}
              <span
                className={classes.viewBtn}
                onClick={() => {
                  setOpenDeleteDialog(true);
                  setAnchorEl(null);
                }}
              >
                <DeleteIcon style={{ color: "red", paddingRight: "5px" }} />
                Delete
              </span>
              {selectedBuyer?.status === "ACTIVE" ? (
                <span
                  className={classes.viewBtn}
                  onClick={() => {
                    setOpenStatusDialog(true);
                    setAnchorEl(null);
                  }}
                >
                  <CancelIcon style={{ color: "red", paddingRight: "5px" }} />
                  Inactive
                </span>
              ) : (
                <span
                  className={classes.viewBtn}
                  onClick={() => {
                    setOpenStatusDialog(true);
                    setAnchorEl(null);
                  }}
                >
                  <CheckIcon style={{ color: "green", paddingRight: "5px" }} />
                  Active
                </span>
              )}
            </Typography>
          </Popover>
        </div>
      ),
    },
  ];

  const auctionBuyersListExportToXLSX = (tableData, tableHeader) => {
    const headerColumns = lodash.map(tableHeader, ({ name }) => {
      if (name != "Action") {
        return name;
      }
    });
    const dataColumns = lodash.map(tableData, (columns) => [
      columns.id,
      columns.userName,
      columns.email,
      columns.contactNumber,
      columns.alternateContactNumber,
      columns.status,
      columns.totalEvents,
      columns.totalItems,
      columns.allotedItems,
      columns.totalBidedItems,
      columns.h1RanksCount,
      columns.h2RanksCount,
      columns.h3RanksCount,
    ]);

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet([headerColumns, ...dataColumns]);

    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "buyer-list.xlsx");
  };

  const AuctionBuyerListExportButton = () => (
    <Button onClick={() => auctionBuyersListExportToXLSX(tableBuyers, columns)}>
      <FaRegFileExcel
        style={{ fontSize: "30px", color: "#04aa18", paddingTop: "4px" }}
      />
    </Button>
  );

  const renderComponent = () => {
    switch (changeView) {
      case "DashBuyerDetail":
        return (
          <DashBuyerDetail
            DashEventDetail={(buyerId, buyerEventId) => {
              SetChangeView("DashEventDetail");
              SetBuyerEventId(buyerEventId);
            }}
            BidlogFirst={() => {
              SetChangeView("AuctionBid");
            }}
            buyerId={buyerId}
          />
        );
      case "DashEventDetail":
        return (
          <DashEventDetail
            BuyerBidLog={(eventItemId) => {
              SetChangeView("BuyerBidLog");
              SetBuyerEvenItemtId(eventItemId);
            }}
            DashBuyerDetail={(buyerId) => {
              SetChangeView("DashBuyerDetail");
              SetBuyerId(buyerId);
            }}
            buyerId={buyerId}
            buyerEventId={buyerEventId}
          />
        );
      case "BuyerBidLog":
        return (
          <BuyerBidLog
            DashEventDetail={() => {
              SetChangeView("DashEventDetail");
            }}
            buyerId={buyerId}
            buyerEventId={buyerEventId}
            buyerEventItemId={buyerEventItemId}
          />
        );
      default:
        return (
          <div className="AuctionTable">
            {userData.role != "BUYER" ? (
              <>
                <h3>Buyer List</h3>
                <DataTableExtensions
                  print={false}
                  export={false}
                  exportHeaders={false}
                  columns={columns}
                  data={tableBuyers}
                >
                  <DataTable
                    noHeader={false}
                    defaultSortField="id"
                    defaultSortAsc={false}
                    pagination
                    highlightOnHover
                    className="DataTable"
                    actions={<AuctionBuyerListExportButton />}
                  />
                </DataTableExtensions>
              </>
            ) : (
              <Navigate to={{ pathname: "/dashboard" }} />
            )}

            <Dialog
              open={openDeleteDialog}
              onClose={() => setOpenDeleteDialog(false)}
            >
              <DialogTitle>{"Delete Buyer ?"}</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Are you sure you want to delete Buyer ?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpenDeleteDialog(false)}>Cancel</Button>
                <Button onClick={handleDeleteBuyer} autoFocus>
                  Delete
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog
              open={openStatusDialog}
              onClose={() => setOpenStatusDialog(false)}
            >
              <DialogTitle>{"Update Buyer Status ?"}</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Are you sure you want to change status of Buyer ?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpenStatusDialog(false)}>Cancel</Button>
                <Button onClick={handleUpdateStatus} autoFocus>
                  Update
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog open={openEditDialog} onClose={() => setOpenEditDialog(false)}>
              <DialogTitle>Edit Buyer</DialogTitle>
              <DialogContent sx={{ display: "grid", gap: 2, minWidth: 420 }}>
                <TextField
                  label="First Name"
                  value={editForm.firstName}
                  onChange={(e) =>
                    setEditForm((prev) => ({ ...prev, firstName: e.target.value }))
                  }
                  fullWidth
                />
                <TextField
                  label="Last Name"
                  value={editForm.lastName}
                  onChange={(e) =>
                    setEditForm((prev) => ({ ...prev, lastName: e.target.value }))
                  }
                  fullWidth
                />
                <TextField
                  label="Email"
                  value={editForm.email}
                  onChange={(e) =>
                    setEditForm((prev) => ({ ...prev, email: e.target.value }))
                  }
                  fullWidth
                />
                <TextField
                  label="Mobile Number"
                  value={editForm.contactNumber}
                  onChange={(e) =>
                    setEditForm((prev) => ({ ...prev, contactNumber: e.target.value }))
                  }
                  fullWidth
                />
                <TextField
                  label="Alt. Mobile Number"
                  value={editForm.alternateContactNumber}
                  onChange={(e) =>
                    setEditForm((prev) => ({
                      ...prev,
                      alternateContactNumber: e.target.value,
                    }))
                  }
                  fullWidth
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpenEditDialog(false)}>Cancel</Button>
                <Button onClick={handleUpdateBuyer}>Save</Button>
              </DialogActions>
            </Dialog>
          </div>
        );
    }
  };

  return (
    <div className={classes.section}>
      <div className="container">
        <div className={classes.Dashboard}>
          <div className={classes.dashboardCard}>
            <DashboardMenu />
            <div className={classes.dashboardCards}>{renderComponent()}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashBuyer;
